import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function useSeo(title, description) {
  const site = useSite();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!site) return;
    const name = site.company_display_name;
    const full = title && title !== name ? `${title} | ${name}` : `${name} (${site.short_name})`;
    const desc = description || site.default_meta_description;
    const url = `${site.site_url}${pathname === "/" ? "/" : pathname}`;
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setCanonical(url);
  }, [site, title, description, pathname]);
}
